
<div [ngClass]="{'custom_zindex' : tenantPropertyInfo}" class="map_section {{classname}}" [class.map-without-report] = "draw_btn_toggle" [class.isReport] = "isReport && (is_save_allow || (studyName.toLocaleLowerCase() === 'apartment' && (reportName.toLocaleLowerCase() === 'occupancy_and_lease' || reportName.toLocaleLowerCase() === 'inventory_in_all_the_neighborhoods' || reportName.toLocaleLowerCase() === 'units' || reportName.toLocaleLowerCase() === 'property_profiling')))">
<div id="map" #mapIdentifier [ngClass]="{'arb-map': current_lang == 'ar'}" [ngStyle]="{'margin-top' : reportId ? '60px' : '0px', 'height' : reportId ? 'calc(100vh - 143px)' : 'calc(100vh - 83px)'}">
    <div class="map-spinner" *ngIf="map_spinner">
        <mat-spinner class="background" mode="determinate" value="100">
        </mat-spinner>
        <mat-spinner class="mat-spin"></mat-spinner>
    </div>

<svg width="0" height="0" id="dynamic-pattern-defs">
  <defs>
    <pattern id="myPattern" patternUnits="userSpaceOnUse" width="40" height="40">
      <image href="../../../../assets/images/arrowDown.svg" x="0" y="0" width="40" height="40" />
    </pattern>
  </defs>
</svg>

    <div class="draw-toolbar"
        [ngStyle]="{'margin': draw_btn_toggle ? '10px':''} "
        *ngIf="draw_btn_toggle">
        <ng-container *ngIf="polygon_create">
            <app-draw-catchment
            [drawnPolygons]="drawnPolygons"
            [filterList]="filterList"
            [polygon_chip]="polygon_chip"
            [polygon_create]="polygon_create"
            (polygonRemove)="polygonWKTRemove($event)"
            (catchmentExpandCol)="catchmentExpand($event)"
            (resetCatchmentConfirm)="resetCatchmentConfirm()"
            (loadCatchmentModel)="loadCatchmentModel()"
            (drawNewCatchmentLoad)="drawNewCatchmentLoad()"
        ></app-draw-catchment>

        </ng-container>


        <button
            [disabled]="reportService.getLockReport()"
            *ngIf="!polygon_create  && reportName?.toLocaleLowerCase() !== 'population'"
            id="draw_polybtn"
            class="draw-btn"
            [matMenuTriggerFor]="catchment"
            (click)="savedCatchment.length === 0 ? drawPolygon() : null; $event.stopPropagation()"
            >
            <img *ngIf="reportService.getLockReport()" class="lock" src="assets/images/Lock-disable.png" alt="">
            <i class="setCatchment-icon"></i>
            <span *ngIf="!polygon_create">{{"map.set_catchment" | translate}}</span>
        </button>

        <div class="load" *ngIf="loadCatchmentShow">
            <app-load-catchment (closeLoadCatchment)="closeLoadCatchment($event)"></app-load-catchment>
        </div>
        
        <div *ngIf="polygon_create" class="drow-control">
          <button (click)="enableDrawing('Polygon')"><img [class.active_shap]="SelectedShap == 'Polygon'" src="../../../../assets/map-icons/multi.svg" alt="">{{'map.polygon' | translate}}</button>
          <button (click)="enableDrawing('Rectangle')"><img [class.active_shap]="SelectedShap == 'Rectangle'" src="../../../../assets/map-icons/ract.svg" alt="">{{'map.rectangle' | translate }}</button>
          <button (click)="enableDrawing('Circle')"><img [class.active_shap]="SelectedShap == 'Circle'" src="../../../../assets/map-icons/circle.svg" alt="">{{'map.circle' | translate}}</button>          
        </div>

        <mat-menu #catchment="matMenu" class="catchment-panel" [xPosition]="current_lang == 'ar' ? 'before' : 'after'">
            <ul class="catchment-menu" (click)="$event.stopPropagation()">
                <li (click)="drawPolygon();">{{'reports.drawNewCatchment' | translate}}</li>
                <li (click)="loadCatchment()">{{'reports.viewSavedCatchment' | translate}}</li>
            </ul>

        </mat-menu>
    </div>
    <ng-container *ngIf="draw_btn_toggle">
      <div class="universalSearchContainer">
        <div class="search-setting">
          <div class="universal-search-btn-chip">
            <div style="position: relative;">
              <mat-chip-row *ngIf="isShowChip" class="searchedProperty searchedPropertyOnDrawPolygon">
                {{Searched_properties?.property_name || ''}}
                <mat-icon matChipRemove (click)="closeChip(true)" class="remove-property">close</mat-icon>
              </mat-chip-row>
              <div class="search-address-hover">
                <app-searched-address [hover]="true" [Searched_properties]="Searched_properties" [current_lang]="current_lang"></app-searched-address>
              </div>
            </div>
            <div class="map-filter map-search-comman">
              <button (click)="openMapSearch(); $event.stopPropagation()" class="map-filter_icns map-filter_icns-common" [class.active-map-search] = "isShowChip || isOpenMapSearch" matTooltip="{{'reports.search'| translate}}"><mat-icon
                  svgIcon="searchIcon"></mat-icon></button>
              <button (click)="layerToggle(); $event.stopPropagation()" class="map-filter_icns map-filter_icns-common" [class.activeLayer]="mapLayertoggle"  matTooltip="{{'reports.map-settings'|translate}}"><mat-icon
                    svgIcon="layerIcon"></mat-icon></button>
            </div>
            <app-map-layers #customLayerOverlay [mapLayertoggle]="mapLayertoggle" [mapZoom]="map?.getView().getZoom()" [is_avg_transaction]="is_avg_transaction" [is_transaction_table]="is_transaction_table" [is_rental_table]="is_rental_table"></app-map-layers>
          </div>
          <!--  -->
          <ng-container *ngIf="isOpenMapSearch">
           <app-universal-search [Searched_properties]="Searched_properties"
           (SearchedParcelOnMap)="locateSearchedParcelOnMap($event)"
           [cityCode]="cityCode"
           (closeChip)="closeChip(false, $event); $event.stopPropagation()"></app-universal-search>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="tenentContaine">
      <div class="tenant-names d-flex align-items-center" *ngIf="TenantName">
        {{'reports.show_on_map' | translate}}:
        <div class="tenant-btn d-flex align-items-center">
        <button (click)="recenterMap()">
          <span class="name_t" dir="ltr"  [matTooltip]="TenantName" matTooltipPosition="above" >{{TenantName}}</span>
        </button>
        <span class="icon" (click)="removeCustomMaker(true); $event.stopPropagation()">
          <mat-icon class="remove-filter">close</mat-icon>
        </span>
      </div>
      </div>
    </div>
<div class="legendContainerMap">
    <div class="legendContainer map_legend" *ngIf="legendToggle && (legend_data_by_group?.length || clusterInfoList?.length > 0)"
        [ngStyle]="{'direction': current_lang == 'ar' ? 'ltr':''} ">
      <div>
        <span class="legendContainer_header"><span>{{'Map Legend' | translate}}
                ({{layerselected}})</span> <span class="legend_close" (click)="collapseLegend()"><img
                    class="legend_close" src="../../../../assets/images/cross.svg" /></span></span>
                    <!-- Cluster Info Section -->
                    <div class="legend-cluster-info" *ngIf="clusterInfoList?.length > 0">
                      <span class="mapLegend" style="font-weight: 700;">{{'reports.clusterInfo' | translate}}</span>

                      <p class="d-flex align-items-center" *ngFor="let list of clusterInfoList">
                        <ng-container *ngIf="list?.count; else listTemplate">
                        <span class="legendcolor projectCircle developed"  [ngStyle]="{'background-color': list.color, 'border-color':list.color}"></span> {{list.name}}
                      </ng-container>
                        <ng-template #listTemplate>
                          <ng-container *ngIf="is_rental_table; else listTemplateTransactions">
                          <img [src]="list.img" alt="">
                          {{list.name}} ({{list.symbol}} )
                          </ng-container>
                        </ng-template>
                        <ng-template #listTemplateTransactions>
                          <img [src]="list.img" alt="">
                          {{list.name}}<br>({{list.symbol}})
                        </ng-template>

                      </p>
                    </div>
        <div *ngFor="let main_legend of legend_data_by_group;let idx = index;">
            <span class="mapLegend" style="font-weight: 700;">{{ main_legend.label[current_lang_id]?main_legend.label[current_lang_id]:main_legend?.label[1] }}</span>
            <div *ngFor="let legend of main_legend.data;let idx = index; let isLast=last;" class="mapLegend rows">
                <div style="display: flex;">
                        <ng-container *ngIf="main_legend?.circle; else elseLegend"><span class="legendcolor projectCircle" [ngClass]="{'developed':legend?.developed }" [ngStyle]="{'background-color': legend?.developed ? legend.color : 'transparent', 'border-color':legend.color}"></span></ng-container>
                        <ng-template #elseLegend>
                          <ng-container *ngIf="legend?.pattern; else defaultLegend">
                            <span class="legendcolor"> <img src="{{legend?.image}}" alt="" width="12" height="12"></span>
                          </ng-container>
                        </ng-template>
                        <ng-template #defaultLegend>
                          <span class="legendcolor" [class.circle]="main_legend.legend_type == 'grade'" [ngStyle]="{'background-color': legend.color}"></span>
                        </ng-template>
                        <span class="legendLabel" [matTooltip]="legend?.label?.[current_lang_id]?.length > 25 ? legend?.label?.[current_lang_id]?legend.label[current_lang_id]:legend?.label?.[1] : ''" matTooltipPosition="below" matTooltipClass="non-interactive-tooltip">{{ legend?.label?.[current_lang_id]?legend.label[current_lang_id]:legend?.label?.[1] }}</span>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
</div>

<app-reports-tenants-map-view *ngIf="tenantPropertyInfo" [propertyInfo]="tenantPropertyInfo"></app-reports-tenants-map-view>
</div>

<ng-container *ngIf="showAreaToggle && (currentReportView === viewType.gridView || currentReportView === viewType.mapGridView)">
    <div class="mapLayer-panel"
    [ngClass]="{'mapLayer-fullpanel': showAreaToggle && currentReportView === viewType.gridView }">
      <app-report-neigh-area-details [propertyInfo]="neightInfo"></app-report-neigh-area-details>
    </div>
</ng-container>

<ng-container *ngIf="reportService.isProjectDetailOpen() && (currentReportView === viewType.gridView || currentReportView === viewType.mapGridView)">
    <div class="mapLayer-panel project-detail-scroll" [ngClass]="{'mapLayer-fullpanel': reportService.isProjectDetailOpen() && currentReportView === viewType.gridView }">
        <app-report-project-details [projectInfo]="selected_property" [propertyUid]="propertyUid"></app-report-project-details>
    </div>
</ng-container>

<ng-container *ngIf="propertyinfoToggle && (currentReportView === viewType.gridView || currentReportView === viewType.mapGridView)">
    <div class="mapLayer-panel property-detail-scroll"
        [ngClass]="{'mapLayer-fullpanel': currentReportView === viewType.gridView }">
        <app-common-property-detail-page [property]="selected_property"></app-common-property-detail-page>
        <!-- <app-power-bi-property-details [property]="selected_property"></app-power-bi-property-details> -->
    </div>
</ng-container>
